<template>
    <div class="details_container">
        <TimeSelector @getSelectedDateData="setDate" />
        <SelectPopOver @setActiveType="setActiveType" />
    </div>
    <div class="cards_row">
        <van-row class="cards_row_content" justify="space-between">
            <van-col span="8">
                <div class="card1">
                    <div>R$ <span>{{ formatCurrency(rewardData.summary.commission) }}</span></div>
                    <div style="padding: 5px;">{{ $t('agent.commission') }}</div>
                </div>
            </van-col>
            <van-col span="7">
                <div class="card2">
                    <div><span>{{ rewardData.summary.commissionRate }}%</span></div>
                    <div style="padding: 5px;">{{ $t('agent.commissionRate') }}</div>
                </div>
            </van-col>
            <van-col span="8">
                <div class="card3">
                    <div>R$ <span>{{ formatCurrency(rewardData.summary.total) }}</span></div>
                    <div style="padding: 5px;">{{ $t('agent.totalCommission') }}</div>
                </div>
            </van-col>
        </van-row>
    </div>
    <div class="tabel_content">
        <div v-if="activeType == 1">
            <van-row class="tabel_hed">
                <van-col span="8" class="head_alignemnet">{{ $t('agent.directPlayer') }}</van-col>
                <van-col span="2" class="head_alignemnet">
                    <div class="line"></div>
                </van-col>
                <van-col span="4" class="head_alignemnet">{{ $t('agent.rollover') }}</van-col>
                <van-col span="2" class="head_alignemnet">
                    <div class="line"></div>
                </van-col>
                <van-col span="8" class="head_alignemnet">{{ $t('agent.commission') }}</van-col>
            </van-row>
            <van-row class="tabel_row" v-for="(item, index) in detailsList" :key="index">
                <van-col span="9" class="head_alignemnet">{{ item.fromUid }}</van-col>
                <van-col span="6" class="head_alignemnet">{{ item.turnover }}</van-col>
                <van-col span="9" class="head_alignemnet">{{ item.coin }}</van-col>
            </van-row>
        </div>
        <div v-if="activeType == 2">
            <van-row class="tabel_hed">
                <van-col span="8" class="head_alignemnet">{{ $t('agent.directPlayer') }}</van-col>
                <van-col span="2" class="head_alignemnet">
                    <div class="line"></div>
                </van-col>
                <van-col span="3" class="head_alignemnet">{{ $t('agent.rollover') }}</van-col>
                <van-col span="2" class="head_alignemnet">
                    <div class="line"></div>
                </van-col>
                <van-col span="3" class="head_alignemnet">{{ $t('common.level') }}</van-col>
                <van-col span="2" class="head_alignemnet">
                    <div class="line"></div>
                </van-col>
                <van-col span="4" class="head_alignemnet">{{ $t('agent.commission') }}</van-col>
            </van-row>
            <van-row class="tabel_row" v-for="(item, index) in detailsList" :key="index">
                <van-col span="9" class="head_alignemnet">{{ item.fromUid }}</van-col>
                <van-col span="5" class="head_alignemnet">{{ item.turnover }}</van-col>
                <van-col span="5" class="head_alignemnet">{{ item.level }}</van-col>
                <van-col span="5" class="head_alignemnet">{{ item.coin }}</van-col>
            </van-row>
        </div>


        <NoData v-if="detailsList.length <= 0" />
        <van-row v-if="total >= pageNumber">
            <van-col span="24" class="arrowDown"> <img src="@/assets/home/game_arrow_white.png" alt=""
                    @click="getNextPageRewardData"></van-col>
        </van-row>
    </div>

    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import SelectPopOver from './selectPopOver.vue';
import TimeSelector from './timeSelector.vue';
import { getRewardDetail } from '@/api/agent';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { formatCurrency } from '@/utils/commonFunction';
import { getRewardDetailDataFunc, RewardDetails, DetailsItem, getNextPageDetailsViewDataFunc } from '@/view/agent/supportScript';
import NoData from '../../components/common/noData.vue';

const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const loadingRef = ref()
const detailsList = ref<DetailsItem[]>([])
const total = ref(0)
const pageSize = ref(20)
const pageNumber = ref(1)
const activeType = ref(1)
const formatYMD = (date: Date): string => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

const today = new Date();
const date = ref(formatYMD(today));

const rewardData = ref<RewardDetails>({
    summary: {
        commission: 0,
        commissionRate: 0,
        total: 0,
    },
    details: [],
    totalPage: 0
})
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const setDate = (value: any) => {
    date.value = value
    detailsList.value = []
    pageNumber.value = 1
    loadingRef.value.open()
    getRewardData()
}
const setActiveType = (type: any) => {
    detailsList.value = []
    activeType.value = type
    loadingRef.value.open()
    getRewardData()

}
const getNextPageRewardData = () => {
  getNextPageDetailsViewDataFunc(total,pageNumber,getRewardData,loadingRef)
}
const getRewardData = () => {
    getRewardDetailDataFunc(
        getRewardDetail,
        date,
        pageNumber,
        activeType,
        rewardData,
        detailsList,
        total,
        loadingRef,
        showError
    )
}

onMounted(() => {
    loadingRef.value.open()
    getRewardData()
})
</script>

<style scoped>
.details_container {
    padding: 10px 15px;
}

.cards_row {
    padding: 10px 25px;
    /* min-height: 110px; */
}


.cards_row_content {
    font-size: 13px;
    color: #ffffff82;
    height: max-content;
}

.card {
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.45);
    font-size: 13px;
    font-weight: bold;
}

.card1 {
    background: #72532e85;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    height: 90%;
    padding: 5%;
}

.card1 span {
    font-size: 20px;
    font-weight: bold;
    padding: 5px;
    color: #fff;
}

.card2 {
    background: #72532e85;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    height: 90%;
    padding: 5%;
}

.card2 span {
    font-size: 20px;
    font-weight: bold;
    padding: 5px;
    color: #fff;
}

.card3 {
    background-image: linear-gradient(166deg, #784a03 0%, #311e06 100%);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    height: 90%;
    padding: 5%;
}

.card3 span {
    font-size: 20px;
    font-weight: bold;
    padding: 5px;
    color: #fff;
}

.card span {
    color: #fff;
    font-size: 24px;
    padding: 0 5px;
}

.tabel_content {
    border-radius: 8px;
    overflow: hidden;
    margin: 10px 15px 15px;
}

.tabel_hed {
    background: rgba(255, 255, 255, 0.15);
    color: rgba(255, 255, 255, 0.85);
    padding: 8px 15px;
    font-weight: bold;
}

.head_alignemnet {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
}

.line {
    width: 1px;
    height: 25px;
    background-color: rgba(255, 255, 255, 0.08);
}

.tabel_row {
    color: rgba(255, 255, 255, 0.85);
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    padding: 10px;
    font-size: 13px;
    background: #ffffff0a;
}

.arrowDown {
    display: flex;
    justify-content: center;
    padding: 15px;

}

.arrowDown img {
    width: 25px;
    transform: rotate(-90deg);
}
</style>